<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Employee List
        </h4>

        <div class="d-flex">
          <a href="javascript: void(0);" class="btn btn-primary ml-auto" placement="top"
            (click)="openModal(addEmployeeModal, {}, 'Add Employee')" ngbTooltip="Add Employee">
            + Add Employee
          </a>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Username</th>
              <th scope="col">Email</th>
              <th scope="col">Date</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of data">
              <td>{{ d?.name }}</td>
              <td>{{ d?.username }}</td>
              <td>{{ d?.email }}</td>
              <td>{{ d?.created_at | date : "medium" }}</td>
              <td>
                <a href="javascript: void(0);" class="link mr-2" placement="top"
                  (click)="openEmployeeDetailsModal(employeeDetailsModal, d)" ngbTooltip="View Details">
                  <i class="fa fa-eye"></i>
                </a>
                <a href="javascript: void(0);" class="link mr-2" placement="top"
                  (click)="openModal(addEmployeeModal, d, 'Delete Employee')" ngbTooltip="Delete">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="data.length == 0">
              <td colspan="5">No data found</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center mt-5">
          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalcount" [maxSize]="7"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Employee Add/Delete Modal -->
<ng-template #addEmployeeModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="addEmployeeLabel">{{ modeltitle }}</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form *ngIf="modeltitle == 'Add Employee'" (ngSubmit)="onSubmit(specialityform)" #specialityform="ngForm">
      <div class="row">
        <div class="col-md-12">
          <div class="card-header bg-primary text-white">
            <h5 class="mb-0">Employee Details</h5>
          </div>
          <br />
          <div class="form-group">
            <label for="name">Name</label>
            <input type="text" placeholder="Enter Name" class="form-control" name="name" [(ngModel)]="detail.name"
              id="name" ngModel required />
          </div>
          <div class="form-group">
            <label for="employeeEmail">Email</label>
            <input type="email" placeholder="Enter Email" class="form-control" name="email" [(ngModel)]="detail.email"
              id="email" ngModel required pattern="^\S+$" #emailRef="ngModel" />
            <div *ngIf="emailRef.invalid && emailRef.touched" class="text-danger">
              Space is not allowed in email.
            </div>
          </div>

          <div class="form-group">
            <label for="username">Username</label>
            <input type="text" placeholder="Enter Username" class="form-control" name="username"
              [(ngModel)]="detail.username" id="username" ngModel required pattern="^\S+$" #usernameRef="ngModel" />
            <div *ngIf="usernameRef.invalid && usernameRef.touched" class="text-danger">
              Space is not allowed in username.
            </div>
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <div class="input-group">
              <input [type]="showPassword ? 'text' : 'password'" placeholder="Enter Password" class="form-control"
                name="password" [(ngModel)]="detail.password" id="password" ngModel required />
              <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary" (click)="togglePasswordVisibility()">
                  <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
              <h5 class="mb-0">Permissions</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div *ngFor="let category of permissionsByCategory | keyvalue : keepOrder" class="col-md-12 mb-3">
                  <div class="d-flex align-items-center"
                    *ngIf="!isDashboardPermission(category.key == 'Dashboard'? 'employee-dashboard':true)">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input align-items-center"
                        [id]="'select-all-' + category.key.replace(' ', '-')"
                        [checked]="areCategoryPermissionsSelected(category.key)"
                        (change)="toggleCategoryPermissions(category.key, $event)" />
                      <label class="form-check-label" [for]="'select-all-' + category.key.replace(' ', '-')">
                      </label>
                    </div>
                    <h5 class="font-weight-bold mb-0 mr-3 mt-1">
                      {{ category.key }} :-
                    </h5>
                  </div>
                  <div class="pl-3 mt-2 d-flex flex-wrap gap-23 row-gap-6px">
                    <div *ngFor="let permission of category.value" class="form-check">
                      <div>
                        <input type="checkbox" class="form-check-input" id="permission-{{ permission.module }}"
                          [checked]="isPermissionSelected(permission.module)"
                          (change)="togglePermission(permission.module)"
                          [disabled]="isDashboardPermission(permission.module)" />
                        <label class="form-check-label" for="permission-{{ permission.module }}">
                          {{ permission.title }}

                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>

    <form [FormGroup]="editUser" *ngIf="modeltitle == 'Delete Employee'">
      Are you sure you want to delete this employee?
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
          Close
        </button>
        <button type="submit" class="btn btn-danger" (click)="delete()">
          Delete
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Employee Details Modal -->
<ng-template #employeeDetailsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Employee Details</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header bg-primary text-white">
            <h5 class="mb-0">Employee Information</h5>
          </div>
          <div class="card-body">
            <div class="form-group row">
              <label class="col-sm-4 font-weight-bold">Name:</label>
              <div class="col-sm-8">
                <p class="form-control-static">{{ employeeDetails?.name }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 font-weight-bold">Email:</label>
              <div class="col-sm-8">
                <p class="form-control-static">{{ employeeDetails?.email }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 font-weight-bold">Username:</label>
              <div class="col-sm-8">
                <p class="form-control-static">
                  {{ employeeDetails?.username }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 font-weight-bold">Created At:</label>
              <div class="col-sm-8">
                <p class="form-control-static">
                  {{ employeeDetails?.created_at | date : "medium" }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Updated Permissions Card with editable checkboxes -->
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-header bg-primary text-white">
            <h5 class="mb-0">Change Password</h5>
          </div>
          <div class="card-body">
            <form (ngSubmit)="onChangePasswordSubmit(passwordForm)" #passwordForm="ngForm">
              <div class="form-group">
                <label for="newPassword">New Password</label>
                <div class="input-group">
                  <input [type]="showNewPassword ? 'text' : 'password'" placeholder="Enter New Password"
                    class="form-control" name="newPassword" [(ngModel)]="passwordData.newPassword" id="newPassword"
                    required #newPasswordRef="ngModel" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@]{8,}$" />
                  <div class="input-group-append">
                    <button type="button" class="btn btn-outline-secondary" (click)="togglePasswordVisibility('new')">
                      <i [class]="
                          showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                        "></i>
                    </button>
                  </div>
                </div>
                <div *ngIf="newPasswordRef.invalid && newPasswordRef.touched" class="text-danger">
                  Password must be at least 8 characters with uppercase,
                  lowercase and numbers.
                </div>
              </div>

              <div class="form-group">
                <label for="confirmPassword">Confirm Password</label>
                <div class="input-group">
                  <input [type]="showConfirmPassword ? 'text' : 'password'" placeholder="Confirm New Password"
                    class="form-control" name="confirmPassword" [(ngModel)]="passwordData.confirmPassword"
                    id="confirmPassword" required #confirmPasswordRef="ngModel" [pattern]="passwordData.newPassword" />
                  <div class="input-group-append">
                    <button type="button" class="btn btn-outline-secondary"
                      (click)="togglePasswordVisibility('confirm')">
                      <i [class]="
                          showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                        "></i>
                    </button>
                  </div>
                </div>
                <div *ngIf="
                    confirmPasswordRef.invalid && confirmPasswordRef.touched
                  " class="text-danger">
                  Passwords do not match.
                </div>
              </div>

              <div class="form-group mt-4">
                <button type="submit" class="btn btn-primary" [disabled]="!passwordForm.valid">
                  Update Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card mt-3">
          <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Permissions</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div *ngFor="let category of permissionsByCategory | keyvalue : keepOrder" class="col-md-12 mb-3">
                <div class="d-flex align-items-center mb-2"
                  *ngIf="!isDashboardPermission(category.key == 'Dashboard'? 'employee-dashboard':true)">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input"
                      [id]="'select-all-' + category.key.replace(' ', '-')"
                      [checked]="areCategoryPermissionsSelected(category.key)"
                      (change)="toggleCategoryPermissions(category.key, $event)" />
                    <label class="form-check-label" [for]="'select-all-' + category.key.replace(' ', '-')">
                    </label>
                  </div>
                  <h5 class="font-weight-bold mb-0 mr-3 mt-1">
                    {{ category.key }} :-
                  </h5>
                </div>

                <div class="row pl-3">
                  <div *ngFor="let permission of category.value" class="col-md-4 form-check mb-2">
                    <div>
                      <input type="checkbox" class="form-check-input" id="viewPermission-{{ permission.module }}"
                        [checked]="isPermissionSelected(permission.module)"
                        (change)="togglePermission(permission.module)"
                        [disabled]="isDashboardPermission(permission.module)" />
                      <label class="form-check-label" for="viewPermission-{{ permission.module }}">
                        {{ permission.title }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary float-right" (click)="savePermissions()">
              <i class="fa fa-save"></i> Save Permissions
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
      Close
    </button>
  </div>
</ng-template>